module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Medium.9008adfa.woff2";